import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from 'react-router-dom';
import Modal from 'react-modal';

const SidebarLink = styled(Link)`
  display: flex;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  height: 29px;
  text-decoration: none;
  font-size: 1.375rem;
  margin-bottom: 1.8rem;
  margin-top: 1.8rem;
 // transition: all 0.3s ease;
  border-left: 4px solid transparent;
 
  &:hover {
    cursor: pointer;
    color: #fff;
    font-weight: bold;
   /// background: rgba(255, 255, 255, 0.1);
   // border-left: 4px solid #fff;
   // padding: 1.5rem;
  }

  &.active {
    background: rgba(255, 255, 255, 0.1);
    border-left: 4px solid #fff;
  }
`;

const SidebarLabel = styled.span`
  // margin-left: 8px;
  font-size: medium;
`;

const DropdownLink = styled(Link)`
  height: auto;
  padding-left: 3.8rem !important;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-size: 0.838rem !important;
  border-left: 4px solid transparent;
  position: relative;
  transition: all 0.3s ease;
  padding: 8px 0;
  margin-bottom: 0.8rem;
  margin-top: 0.8rem;
  opacity: 0.6;
 
  &:hover {
    cursor: pointer;
    color: #fff;
   // background: rgba(255, 255, 255, 0.1);
  }

  &.sub_active {
   // background: rgba(255, 255, 255, 0.1);
    //border-left: 4px solid #fff;
    font-weight: bold;
    opacity: 1;
    position: relative;
  }
 
`;

const Menu = ({ item }) => {
  const location = useLocation();
  const [subnav, setSubnav] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));

  // Check if current location matches any submenu item
  const isSubMenuActive = item.subNav && item.subNav.some(subItem => location.pathname === subItem.path);

  // Check if main menu item should be active (either direct match or submenu is active)
  // Also highlight dashboard by default when on root path
  const isMainMenuActive =
    location.pathname === item.path ||
    isSubMenuActive ||
    (item.title === "Dashboard" && (location.pathname === "/" || location.pathname === "/dashboard"))

  // Auto-open submenu if any submenu item is active
  useEffect(() => {
    if (isSubMenuActive) {
      setSubnav(true);
    }
  }, [isSubMenuActive]);

  const showSubnav = () => {
    setSubnav(!subnav);
  };

  const user_details = JSON.parse(localStorage.getItem('user_details'));
  const postOfIcMember = user_details?.post_of_ic_member;

  // console.log("Post of IC Member:", postOfIcMember);
  // let user_details = sessionStorage.getItem("user_details");
  const itemStyle = item.title === 'View Users' && (postOfIcMember !== 'Presiding Officer' || postOfIcMember === null)
    // && orgInfo?.plan_id !== 'plan_122342567823'
    // && orgInfo?.plan_id !== 'plan_122342567976'
    // && orgInfo?.plan_id !== 'plan_122342567821'
    ? {
      // pointerEvents: 'none',
      opacity: 0.6
      // cursor: 'not-allowed'
    }
    : {
      opacity: !item.is_display ? 0.6 : 1,
    };

  const openPremiumModal = () => {
    setModalOpen(true);
  };

  const closePremiumModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <SidebarLink
        to={item.is_display ? item.path : '#'}
        onClick={
          item.title === 'View Users'
            && postOfIcMember !== 'Presiding Officer'
            // && orgInfo?.plan_id !== 'plan_122342567823'
            // && orgInfo?.plan_id !== 'plan_122342567976'
            // && orgInfo?.plan_id !== 'plan_122342567821'
            ? (e) => { e.preventDefault(); openPremiumModal(); }
            : item.is_display
              ? (item.subNav && showSubnav)
              : (e) => { e.preventDefault(); openPremiumModal(); }
        }
        className={isMainMenuActive ? 'active' : ''}
        style={itemStyle}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={item.icon} alt="" />
            <SidebarLabel>{item.title}</SidebarLabel>
          </div>
          {(item.title === 'View Users'
            && postOfIcMember !== 'Presiding Officer'
            // && orgInfo?.plan_id !== 'plan_122342567823'
            // && orgInfo?.plan_id !== 'plan_122342567976'
            // && orgInfo?.plan_id !== 'plan_122342567821'
          ) ? (
            <img src='/images/lock_img.svg' alt="Locked" style={{ marginRight: '8px' }} />
          ) : (
            item.is_display ? null : <img src={item.lockIcon} alt="Locked" onClick={(e) => { e.preventDefault(); openPremiumModal(); }} style={{ marginRight: '8px' }} />
          )}
        </div>
        <div>
          {item.title === "Compliance" && item.is_display && (
            subnav ? (
              <span className="ms-1 me-4" style={{fontSize: '10px'}}>&#9650;</span>
            ) : (
              <span className="ms-1 me-4" style={{fontSize: '10px'}}>&#9660;</span>
            )
          )}
        </div>


      </SidebarLink>
      {subnav && item.subNav.map((subItem, index) => {
        const isSubItemActive = location.pathname === subItem.path;
        return (
          <DropdownLink
            style={{
              opacity: isSubItemActive ? 1 : 0.6,         
              pointerEvents: 'auto',                     
            }}
            // style={{
            // pointerEvents: (!subItem?.is_display && subItem?.is_display !== undefined) ? 'none' : 'auto',
            // opacity: (!subItem?.is_display && subItem?.is_display !== undefined) ? 0.6 : 1,
            //  cursor: (!subItem?.is_display && subItem?.is_display !== undefined) ? 'not-allowed' : 'pointer'
            // }}
            to={subItem.path}
            key={index}
            className={isSubItemActive ? 'sub_active' : ''}
            onClick={!subItem?.is_display && orgInfo?.plan_id === 'plan_1234567890' && subItem?.title !== 'POSH Policy' ? (e) => { e.preventDefault(); openPremiumModal(); } : undefined}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
             <SidebarLabel style={{ color: isSubItemActive ? '#fff' : '#fff' }}>
                {subItem?.title}
              </SidebarLabel>
              {!subItem?.is_display ? <img src={subItem?.lockIcon} style={{ marginRight: '8px' }}></img> : ''}
            </div>
          </DropdownLink>
        );
      })}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closePremiumModal}
        contentLabel="Video Modal"
        className='videoModal bg-white  w-25 p-4'
      >
        <div className='d-flex justify-content-start align-items-center border-bottom text-left pb-2'>
          <h2 className='font-20 fw-bold text-left mb-2'>From Compliance to Safety</h2>
        </div>
        <div className='modal-body py-4'>
          <p className='small'>
            Take safety beyond the basics. Upgrade now to access advanced features that drive real change.<br /> Contact us to upgrade your plan.
          </p>
        </div>
        <div className="text-center border-top pt-2">
          <button className='btn btn-primary py-1 px-4 mt-2 mx-auto' onClick={closePremiumModal}>Ok</button>
        </div>
      </Modal>
    </>
  );
};

export default Menu;

